import { createSlice } from '@reduxjs/toolkit';

import type { MarcoTeste, TrialStatusItem } from '../../types';
import { fetchTrialStatus } from './actions';

interface TrialStatusState {
  itens: TrialStatusItem[];
  marcoMaisGrave: MarcoTeste | null;
  loading: boolean;
  error: string | null;
}

const initialState: TrialStatusState = {
  itens: [],
  marcoMaisGrave: null,
  loading: false,
  error: null,
};

const trialStatusSlice = createSlice({
  name: 'contractsTrialStatus',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchTrialStatus.pending, (state) => {
        state.itens = [];
        state.marcoMaisGrave = null;
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTrialStatus.fulfilled, (state, action) => {
        state.itens = action.payload.itens;
        state.marcoMaisGrave = action.payload.marcoMaisGrave;
        state.loading = false;
      })
      .addCase(fetchTrialStatus.rejected, (state, action) => {
        state.itens = [];
        state.marcoMaisGrave = null;
        state.loading = false;
        state.error = action.payload ?? 'Erro desconhecido';
      });
  },
});

export const trialStatusReducer = trialStatusSlice.reducer;
